import React, {
  useContext,
  useEffect,
  useRef,
} from 'react';
import {
  useFormContext,
} from 'react-hook-form';
import {
  isEmptyString,
} from '@populateui/utils';
import Button from 'pages/Dashboard/components/Button';
import Controller from 'core/components/FormController';
import Input from 'pages/Dashboard/components/Input';
import Spinner from 'pages/Dashboard/components/Spinner';
import {
  WizardContext,
} from 'pages/Dashboard/pages/Billing/Payments/EOBDialog/wizardContext';

export function LookupStepTitle() {
  return <h3 className="text-lg font-semibold">EOB Lookup</h3>;
}

export default function LookupStep() {
  const inputRef = useRef<HTMLInputElement>(null!);
  const { control, watch } = useFormContext();
  const eobNumber = watch('eob.eobNumber');
  const { fetchingEOB, enableSearch, onClose } = useContext(WizardContext);

  useEffect(() => {
    inputRef?.current?.focus?.();
  }, []);

  return (
    <div className="flex flex-col gap-form-row w-full min-h-[160px]">
      <Controller
        rules={{ required: true }}
        control={control}
        name="eob.eobNumber"
        render={({ field: { onChange, value, ...field } }) => (
          fetchingEOB
            ? (
              <div className="flex-1 flex items-center justify-center">
                <Spinner size={30} />
              </div>
            )
            : (
              <Input
                {...field}
                inputRef={inputRef}
                onChange={onChange}
                value={value}
                required
                className="flex-1"
                label="EOB / CheckOrEFTTrace Number"
                placeholder="Enter EOB / CheckOrEFTTrace Number"
                onBlur={() => {
                  onChange((value ?? '').trim());
                }}
              />
            )
        )}
      />
      <div className="flex items-center justify-end gap-3 mt-2">
        <Button
          variant="outlined"
          onClick={onClose}
        >
          Close
        </Button>
        <Button
          variant="contained"
          color="primary"
          disabled={fetchingEOB || isEmptyString(eobNumber)}
          onClick={() => { enableSearch(true); }}
        >
          Next
        </Button>
      </div>
    </div>
  );
}
